import dayjs from "dayjs";

import { getAttendenceEmployeeDetails } from "../../../../../services/attendanceService";

import { LEAVE_PART_LABELS } from "../constants/attendanceAdmin.constants";

export const toMinutes = (val: unknown): number => {
  if (val == null) return 0;
  const s = String(val).trim().toLowerCase();
  if (!s) return 0;

  const hMatch = s.match(/(\d+(?:\.\d+)?)\s*(?:h(?:ours?)?|hrs?|hr)\b/);
  const mMatch = s.match(/(\d+)\s*m(?:in(?:utes)?)?\b/);

  let mins = 0;
  if (hMatch) mins += Math.round(parseFloat(hMatch[1]) * 60);
  if (mMatch) mins += parseInt(mMatch[1], 10);

  if (!hMatch && !mMatch) {
    const n = parseFloat(s);
    if (!Number.isNaN(n)) mins += Math.round(n * 60);
  }
  return mins;
};

export const calcBreakMinutes = (logs: any[] = []): number => {
  if (!Array.isArray(logs) || logs.length < 2) return 0;

  const sorted = [...logs].sort(
    (a, b) => new Date(a.raw_time).getTime() - new Date(b.raw_time).getTime(),
  );

  let total = 0;
  for (let i = 0; i + 2 < sorted.length; i += 2) {
    const checkout = sorted[i + 1];
    const nextCheckin = sorted[i + 2];

    if (!checkout || !nextCheckin || !checkout.raw_time || !nextCheckin.raw_time) {
      continue;
    }

    const diffMin = dayjs(nextCheckin.raw_time).diff(
      dayjs(checkout.raw_time),
      "minute",
    );
    if (diffMin > 0) total += diffMin;
  }
  return total;
};

export const formatBreakLabel = (mins: number): string => {
  if (!Number.isFinite(mins) || mins <= 0) return "0 m";
  if (mins < 60) return `${mins} Min`;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return `${h}hr :${String(m).padStart(2, "0")} m`;
};

export const getInitials = (name = ""): string => {
  const names = name.split(" ");
  return names
    .map((n) => n[0]?.toUpperCase() || "")
    .join("")
    .slice(0, 2);
};

export const formatLeaveStatus = (status: string, leaveInfo: any): string => {
  if (!leaveInfo) return status;
  const { startDayPart, endDayPart, leave_name } = leaveInfo;
  const partLabel = LEAVE_PART_LABELS[`${startDayPart}|${endDayPart}`];
  if (!partLabel) return status;
  const parts = ["On Leave"];
  if (leave_name) parts.push(leave_name);
  parts.push(partLabel);
  return parts.join(" - ");
};

export const fetchLeaveInfoMap = async (
  userId: any,
  startDate: any,
  endDate: any,
  companyId: any,
  companyType: any,
): Promise<Map<string, any>> => {
  const map = new Map<string, any>();
  if (!userId) return map;
  try {
    const res = await getAttendenceEmployeeDetails(
      userId,
      startDate,
      endDate,
      companyId,
      companyType,
    );
    const items = res?.data?.attendance || [];
    items.forEach((item: any) => {
      if (item.date && item.leave_info) {
        map.set(dayjs(item.date).format("YYYY-MM-DD"), item.leave_info);
      }
    });
  } catch (e) {
    console.error("Failed to fetch leave info for user", userId, e);
  }
  return map;
};
